import PanelSection from "./PanelSection";

export default PanelSection;